module.exports = __webpack_public_path__ + "img/08.fa3bdc0a.jpg";